import { useStorage } from '@vueuse/core'

// eslint-disable-next-line internal/no-call-composable-outside-setup
export const requestedIntegrations = useStorage<string[]>('requestedIntegrations', [])
